import { ErrorHandler } from "@angular/core";
import { Subject } from "rxjs";

export class ObservableErrorHandler implements ErrorHandler {
  private _errorsSubject = new Subject<any>();
  errors$ = this._errorsSubject.asObservable();
  private _clearErrorsSubject = new Subject<any>();
  errorCleared$ = this._clearErrorsSubject.asObservable();

  handleError(error) {
    console.log(error);
    this._errorsSubject.next(error);
  }

  clearError(error) {
    console.log("Error Cleared:");
    console.log(error);
    this._clearErrorsSubject.next(error);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/ObservableErrorHandler.ts